import type { JSONContent } from '@tiptap/core'

/**
 * Converts TipTap JSON content to plain text for search indexing / previews.
 */
export function toPlainText(doc: JSONContent): string {
  if (!doc) return ''
  return extractText(doc).trim()
}

function extractText(node: JSONContent): string {
  if (node.type === 'text') {
    return node.text || ''
  }

  if (node.type === 'mergeTag') {
    return node.attrs?.label || `{{${node.attrs?.templateVar}}}`
  }

  if (node.type === 'mention') {
    return `@${node.attrs?.label || ''}`
  }

  if (node.type === 'ctaButton') {
    return `[${node.attrs?.text || 'Button'}](${node.attrs?.url || ''})`
  }

  if (node.type === 'hardBreak') return '\n'

  const texts = (node.content ?? []).map(extractText)

  if (
    node.type === 'paragraph' ||
    node.type === 'heading' ||
    node.type === 'bulletList' ||
    node.type === 'orderedList'
  ) {
    return texts.join('') + '\n'
  }

  if (node.type === 'listItem') {
    return '- ' + texts.join('')
  }

  return texts.join('')
}
